import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { AddMessageOnDb } from '../store/messages.actions';
import { MessagesState } from '../store/messages.reducer';
import { MessageModel, MessageTypes } from '../models/message.model';
import { StatusService } from './status.lib.service';
import { TreatmentModel, TreatmentStatus } from 'libs/treatments/src/lib/models/treatment.model';


@Injectable({
	providedIn: 'root'
})
export class MessagesService {
	private http = inject(HttpClient);
	private store = inject<Store<MessagesState>>(Store);
	config = inject<AppConfig>(APP_CONFIG_TOKEN);


	/**
	 * Fetches a list of messages regarding the treatmentId as well
	 * as the messages of associated treatments
	 */
	getMessages(treatmentId: string): Observable<MessageModel[]> {
		const params = {
			treatmentId: treatmentId,
			fetchFromAssociatedTreatments: true
		}
		return this.http.get<MessageModel[]>(`${this.config.apiUrl}/messages`, {params, withCredentials: true});
	}

	getMessagesTicket(ticketId: string): Observable<MessageModel[]> {
		const params = {
			ticketId: ticketId,
		}
		return this.http.get<MessageModel[]>(`${this.config.apiUrl}/messages`, {params, withCredentials: true});
	}

	createMessage(message: MessageModel): Observable<MessageModel> {
		return this.http.post<MessageModel>(
			`${this.config.apiUrl}/messages`,
			message,
			{withCredentials: true});
	}

	createTicketMessage(ticketId: string, message: string, messageType: MessageTypes): Observable<MessageModel> {
		const body = {
			ticketId: ticketId,
			message: message,
			messageType: messageType
		}

		return this.http.post<MessageModel>(
			`${this.config.apiUrl}/messages/ticket`,
			body,
			{withCredentials: true});
	}

	resetMessageCount(treatmentId: string): Observable<TreatmentModel> {
		return this.http.post<TreatmentModel>(
			`${this.config.apiUrl}/messages/resetCount`,
			{ id: treatmentId },
			{ withCredentials: true }
		);
	}

	markAdminToCustomerMessagesAsRead(messageIds: string[], treatmentId: string) {
		const body = {
			messageIds: messageIds,
			treatmentId: treatmentId
		}
		return this.http.patch(`${this.config.apiUrl}/messages/customer/readByCustomer`, body, {withCredentials: true});
	}

	createStatusChangeLogMessage(oldStatus: TreatmentStatus, newStatus: TreatmentStatus, treatmentId: string){
		const logMessageModel = StatusService.createStatusChangeLogMessageModel(oldStatus, newStatus, treatmentId);
		this.store.dispatch(new AddMessageOnDb({message: logMessageModel}));
	}
}
